import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e9703b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "post" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 1,
  class: "status"
}
const _hoisted_4 = {
  key: 2,
  class: "status"
}

import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { marked } from 'marked';
import ViewContainer from '../components/ViewContainer.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlogPostView',
  setup(__props) {

const route = useRoute();
const html = ref('');
const state = ref<'loading' | 'ok' | 'error'>('loading');

async function load(slug: string) {
    state.value = 'loading';
    try {
        const res = await fetch(`/posts/${slug}.md`, { headers: { accept: 'text/markdown' } });
        if (!res.ok) throw new Error(String(res.status));
        const md = await res.text();
        html.value = await marked.parse(md, { gfm: true, breaks: false });
        state.value = 'ok';
    } catch {
        state.value = 'error';
    }
}

watch(
    () => route.params.slug,
    (slug) => {
        if (typeof slug === 'string') load(slug);
    },
    { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ViewContainer, null, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        (state.value === 'ok')
          ? (_openBlock(), _createElementBlock("article", {
              key: 0,
              class: "md",
              innerHTML: html.value
            }, null, 8, _hoisted_2))
          : (state.value === 'loading')
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "loading…"))
            : (_openBlock(), _createElementBlock("p", _hoisted_4, "post not found."))
      ])
    ]),
    _: 1
  }))
}
}

})